//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export const GRID_CONTENT_CARD_HEIGHT = 333;
export const GRID_CONTENT_CARD_HEIGHT_NO_METADATA = 204;
export const GRID_CONTENT_CARD_WIDTH = GRID_CONTENT_CARD_HEIGHT_NO_METADATA;

export type ViewMode = 'grid' | 'meta';
